import { render, staticRenderFns } from "./DSwitch.vue?vue&type=template&id=2a983ae3&scoped=true&lang=pug"
import script from "./DSwitch.vue?vue&type=script&lang=js"
export * from "./DSwitch.vue?vue&type=script&lang=js"
import style0 from "./DSwitch.vue?vue&type=style&index=0&id=2a983ae3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a983ae3",
  null
  
)

export default component.exports